export default __webpack_public_path__ + "static/media/logo-settrade.c715e7e8.svg";